export const TOGGLE_FILTER = 'filter/TOGGLE_FILTER';
export const TOGGLE_FILTER_STATE = 'filter/TOGGLE_FILTER_STATE';
export const RESET_FILTERS = 'filter/RESET_FILTERS';

export const FILTER_JOB_ZONE = 'jobZone';
export const FILTER_SUBJECT_AREA = 'subjectArea';
export const FILTER_FORMAT = 'format';
export const FILTER_SCHOOL_SIZE = 'schoolSize';
export const FILTER_SCHOOL_TYPE = 'schoolType';
export const FILTER_DEGREE_TYPE = 'degreeType';
export const FILTER_INDUSTRY = 'industry';
export const FILTER_FAVORITE = 'favorite';
export const FILTER_PROGRAMS = 'programs';
export const FILTER_MOS = 'mos';

const deleteProp = (obj, prop) =>
    (Object.keys(obj)
        .reduce((acc, key) => {
            if (key !== prop) {
                acc[key] = obj[key];
            }
            return acc;
        }, {})
    );

const initialState = {
    jobZone: {},
    subjectArea: {},
    matchStrength: {},
    format: {},
    schoolSize: {},
    degreeType: {},
    schoolType: {},
    industry: {},
    favorite: {},
    programs: {},
    mos: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_FILTER: {
            const { label, filterId, filterOptionId, selected, options } = action;
            return {
                ...state,
                [filterId]: !selected
                    ? { ...state[filterId],
                        [filterOptionId]: {
                            label,
                            selected: true,
                            options,
                        },
                    }
                    : deleteProp(state[filterId], filterOptionId),

            };
        }
        case TOGGLE_FILTER_STATE: {
            const { filterId, filterOptionId, selected } = action;
            return {
                ...state,
                [filterId]: !selected ?
                    {
                        ...state[filterId],
                        [filterOptionId]: {
                            ...state[filterId][filterOptionId],
                            selected: !selected,
                        },
                    }
                    : deleteProp(state[filterId], filterOptionId),
            };
        }
        case RESET_FILTERS: {
            return initialState;
        }
        default:
            return state;
    }
};

/**
 * REDUX ACTIONS
 */

export const toggleFilterAction = (data = {}) => ({
    type: TOGGLE_FILTER,
    ...data,
});

export const toggleFilterStateAction = (data = {}) => ({
    type: TOGGLE_FILTER_STATE,
    ...data,
});

export const resetFiltersAction = () => ({
    type: RESET_FILTERS,
});



// WEBPACK FOOTER //
// ./src/client/redux/filterPrograms.js